import { AppLang } from '@e3dc-react/shell/State/App/AppModel'
import { TemplatesModel } from '../models/pdf-template.model'
import { TemplateCategory } from '../api/dto/pdf-template-category.dto'
import { getCurrentLanguage } from 'src/Libs/languages/functions/default'

/**
 * Function for finding matching application language with available languages for export templates
 * First, we are looking if selected app language is available in templates by category
 * If not, we are searching for English as first backup language
 * If not, we are searching for German as second backup language
 * If not, option menu is disabled with proper text information
 */
export const getTemplateAvailableLanguage = (category: TemplateCategory, templates: TemplatesModel[]): AppLang | undefined => {
  const currentAppLanguage = getCurrentLanguage()

  const availableTemplate = templates.find(template => template.templateCategory === category)

  const isCurrentAppLanguageAvailable = availableTemplate?.templateLocales.some(template => template === currentAppLanguage)

  const isEnglishLanguageAvailable = availableTemplate?.templateLocales.some(template => template === 'en')
  const isGermanLanguageAvailable = availableTemplate?.templateLocales.some(template => template === 'de')

  if (isCurrentAppLanguageAvailable) {
    return currentAppLanguage
  }

  if (isEnglishLanguageAvailable) {
    return 'en'
  }

  if (isGermanLanguageAvailable) {
    return 'de'
  }

  return undefined
}
